import { render, staticRenderFns } from "./CartStep3.vue?vue&type=template&id=c54af312&scoped=true"
import script from "./CartStep3.vue?vue&type=script&lang=js"
export * from "./CartStep3.vue?vue&type=script&lang=js"
import style0 from "./CartStep3.vue?vue&type=style&index=0&id=c54af312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54af312",
  null
  
)

export default component.exports